/*class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');
      if ($(window).width() <= 767){
        $('.choose-cart').css('display','grid');
      }
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.selected_var').innerHTML = $(this).val();
            dropdown.querySelector('.before_select span').innerHTML = 'Selected';
          });
        });
      });
    });
  }
}
document.querySelector('.product-addcart').addEventListener('click',function(evt){
  evt.preventDefault();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  var cartform = document.querySelector('.product-addcart').closest('form');
  const formData = new FormData(cartform);  
  if ($(window).width() <= 767){
    $('variant-radios').slideUp();
  $('.choose-cart').addClass('hide-selectore-button');
  $('.choose-selector').removeClass('hide-selectore-button').css('display','grid');
    atc_bar();
  }
  $('body').removeClass('open_variant');  
  config.body = formData;
  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      if ($(window).width() >= 768){
        document.querySelector('.product-form-error').innerHTML = response.description;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
      },2000);
      }
      else if($(window).width() <= 767){
      $('.cart-added').addClass('active');
        document.querySelector('.blackbar-error').innerHTML = response.description;
        $('.blackbar-error').show(); 
        $('.blackbar-text').hide();   
        setTimeout(function(){
          $('.cart-added').removeClass('active');
        }, 4000);
        
      }
      
      return;
    }else{
      if ($(window).width() >= 768){
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
      }
      else if($(window).width() <= 767){
        if(typeof load_cart == 'function'){
          load_cart();
          setTimeout(function(e){
            $('.cart-added').addClass('active');
            $('.blackbar-error').hide(); 
            $('.blackbar-text').show();
            setTimeout(function(){
              $('.cart-added').removeClass('active');
            }, 4000);
          },500);
        }else{
          window.location.href = "/cart";
        }
      }
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {

  });
});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();


variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top - 67
}
function doScrolling(element, duration) {
  console.log('jigi')
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
// if(document.querySelector('.simple_info .choose-selector')){
//   if (window.innerWidth <= 768) {
//     document.querySelector('.simple_info .choose-selector a').addEventListener('click', doScrolling.bind(null, '.product-media', 500))
//   }
// }



if ($(window).width() <= 767){
  new Swiper('.inner-media', {
    slidesPerView: 1,
    pagination: {
        el: ".swiper-pagination",
    }
  });
  $('.choose-selector').removeClass('hide-selectore-button');
  $(document).ready(function() {
  var h_height = $('.section-header').outerHeight(),
    pr_ttl_height = $('.inner_info_fixed').outerHeight(),
    w_ht = $(window).height(),    
    t_ht = w_ht - (h_height + pr_ttl_height);
  //$('.product-media').height(t_ht);
    var in_top = $('.inner_info_fixed').offset().top;
var m_t_ht = 0;
     $(document).on('click', '.disable_size', function(){
       m_t_ht = $('.product-media').outerHeight() + h_height + pr_ttl_height;
      $('variant-radios').slideToggle();
      $('body').toggleClass('open_variant');
      if ($('.variant-dropdown-list>div input[type=radio]:checked').length > 0){
        $('.choose-cart').css('display', 'grid').removeClass('hide-selectore-button');
        $('.choose-selector').hide();
      }      
    });
    $(document).on('click', '.simple_info .disable_size', function(){
      $( 'html, body' ).animate({
      scrollTop: 0
      }, 500 );
    });

    
    $(window).on('scroll', function(){
      m_t_ht = $('.product-media').outerHeight() + h_height + pr_ttl_height;
      console.log(w_ht, m_t_ht);
      if (w_ht < m_t_ht){
         //$('.product-media').height(t_ht);
      }
      var s_top = $(window).scrollTop();
      if(s_top >= in_top){
           //$('.inner_info_fixed').addClass('sticky_fixed').removeClass('simple_info');  
        $('body').css('padding-top', pr_ttl_height);
        $('#shopify-section-header').addClass('no_sticky');
      }
      else{
       //$('.inner_info_fixed').removeClass('sticky_fixed').addClass('simple_info');
        $('body').css('padding-top', 0);
        $('#shopify-section-header').removeClass('no_sticky');
      }
      if(s_top >= (in_top - 66) ){
        $('#shopify-section-header').addClass('no_sticky');
      }
      else{
        $('#shopify-section-header').removeClass('no_sticky');
      }
      atc_bar();


      var top_total_offset = $(window).height() + s_top;
      var top_info = $('.product-info').offset().top;
      var info_total = $('.inner_info_fixed').offset().top;
      if(top_total_offset >= top_info){
        $('.inner_info_fixed').removeClass('simple_info');
      }
      else{
        $('.inner_info_fixed').addClass('simple_info');
      }
      if (info_total <= s_top){
        $('.inner_info_fixed').addClass('stick');
      }
      else{
        $('.inner_info_fixed').removeClass('simple_info');
      }
      
    });
   
});
  $(document).on('click','.close-blackbar',function(e){
  $('.blackbar').removeClass('active');
  return false;
});
$('body').on('click',function(e){
  var container = $(".inner_info_fixed");
  if (!container.is(e.target) && container.has(e.target).length === 0){
    $('variant-radios').slideUp();
    $('body').removeClass('open_variant'); 
    $('.choose-cart').hide();
    $('.choose-selector').removeClass('hide-selectore-button').css('display','grid')
  }
});
const media_height = () => {
    const docs = document.querySelector('.open_variant .product-media');
  const m_hright = `${window.innerHeight}`;
  const h_height = $('.section-header').outerHeight();
    const pr_ttl_height = $('.inner_info_fixed').outerHeight();
  const t_ht = m_hright - (h_height + pr_ttl_height);
    docs.style.setProperty('height', t_ht+'px')
}
window.addEventListener('resize', media_height)
}
if ($(window).width() >= 768){
  $('body').on('click',function(e){
    var container = $(".variant-dropdown-list, .variant-dropdown");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      $('.dropdown-wrap').removeClass('active');
    }
  });
}
function atc_bar(){
  if ($('.sticky_fixed').length > 0){
    $('.blackbar').css('top', $('.sticky_fixed').outerHeight());
  }
  else{
    $('.blackbar').css('top', $('.section-header').outerHeight());
  }
}

$(document).on('click', '.size_link a', function(){
    $('body').addClass('open_sgiude')

})*/
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
      document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
        dropdown.classList.remove('active');
        dropdown.classList.remove('non-active');
      });
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');
      if ($(window).width() <= 767){
        $('.choose-cart').css('display','grid');
      }
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        const waitlistButton = document.querySelector('.btn.get-notified.klaviyo-bis-trigger');
        if (!(waitlistButton && waitlistButton.classList.contains('coming-soon'))) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    
    if(this.currentVariant != undefined){
      if(this.currentVariant.available){
        if(productForm.querySelector(".choose-cart")) productForm.querySelector(".choose-cart").classList.remove('variant_sold-out');
      }else{
        if(productForm.querySelector(".choose-cart")) productForm.querySelector(".choose-cart").classList.add('variant_sold-out'); 
      }
    }

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown() {
  if (document.querySelector('.dropdown-wrap')) {
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown) {
      dropdown.querySelector('.variant-dropdown').addEventListener('click', function(event) {
        event.preventDefault();
        if (dropdown.classList.contains('non-active')) {
          dropdown.classList.remove('non-active');
        } else {
          dropdown.classList.toggle('active');
        }
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e) {
          e.addEventListener('change', function(button) {

            if (e.hasAttribute('store-only')) {
              document.querySelector('.choose-cart').classList.add('store-only');
              setTimeout(() => {
                const waitlistButton = document.querySelector('.btn.get-notified.klaviyo-bis-trigger');
                if (waitlistButton && waitlistButton.classList.contains('coming-soon')) {
                  waitlistButton.querySelector('span').innerHTML = 'Coming soon\u2003•\u2003join waitlist';
                } else {
                  document.querySelector('.btn.get-notified.klaviyo-bis-trigger span').innerHTML = 'Sold out\u2003•\u2003join waitlist';
                }
              }, 500);
            } else {
              document.querySelector('.choose-cart').classList.remove('store-only');
            }


            var belgiumStore = document.querySelector('.belgium_stores');
            var parisAvail = document.querySelector('.paris_avail');
            
            if (parisAvail && parisAvail.getAttribute('data-store-selected') === '') {
              belgiumStore.innerHTML = `View store availability for size ${e.value}`;
            }

            if (parisAvail) {
              parisAvail.setAttribute('data-size-selected', e.value);
            }
            

            if (document.querySelector('.paris_avail')) {
              var parisAvail = document.querySelector('.paris_avail');
              var storeOptions = document.querySelector('.store_options');
              var closestDiv = e.closest('div');
              var paris_available = document.querySelector('.paris_available a');
              var paris_unavailable = document.querySelector('.paris_unavailable');
              var brussels_available = document.querySelector('.brussels_available a');
              var brussels_unavailable = document.querySelector('.brussels_unavailable');
              var antwerp_available = document.querySelector('.antwerp_available a');
              var antwerp_unavailable = document.querySelector('.antwerp_unavailable');
              var size_selected = parisAvail.getAttribute('data-size-selected');

                if (closestDiv.getAttribute('data-val-paris') == 'true') {
                  parisAvail.classList.add('active-paris');
                  parisAvail.classList.remove('non-active-paris');
                  storeOptions.classList.add('active-paris');
                  storeOptions.classList.remove('non-active-paris');
                  if (paris_available) {
                    paris_available.innerHTML = `Size ${size_selected} is available in Paris store`;
                  }
                } else if (closestDiv.getAttribute('data-val-paris') == 'false' || closestDiv.getAttribute('data-val-paris') == '') {
                  parisAvail.classList.remove('active-paris');
                  parisAvail.classList.add('non-active-paris');
                  storeOptions.classList.remove('active-paris');
                  storeOptions.classList.add('non-active-paris');
                  if (paris_unavailable) {
                    paris_unavailable.innerHTML = `Size ${size_selected} is not available in Paris store`;
                  }
                }
              

              
                if (closestDiv.getAttribute('data-val-antwerp') == 'true') {
                  parisAvail.classList.add('active-antwerp');
                  parisAvail.classList.remove('non-active-antwerp');
                  storeOptions.classList.add('active-antwerp');
                  storeOptions.classList.remove('non-active-antwerp');
                  if (antwerp_available) {
                    antwerp_available.innerHTML = `Size ${size_selected} is available in Antwerp store`;
                  }
                } else if (closestDiv.getAttribute('data-val-antwerp') == 'false' || closestDiv.getAttribute('data-val-antwerp') == '') {
                  parisAvail.classList.remove('active-antwerp');
                  parisAvail.classList.add('non-active-antwerp');
                  storeOptions.classList.remove('active-antwerp');
                  storeOptions.classList.add('non-active-antwerp');
                  if (antwerp_unavailable) {
                    antwerp_unavailable.innerHTML = `Size ${size_selected} is not available in Antwerp store`;
                  }
                }
                            
                if (closestDiv.getAttribute('data-val-brussels') == 'true') {
                  parisAvail.classList.add('active-brussels');
                  parisAvail.classList.remove('non-active-brussels');
                  storeOptions.classList.add('active-brussels');
                  storeOptions.classList.remove('non-active-brussels');
                  if (brussels_available) {
                    brussels_available.innerHTML = `Size ${size_selected} is available in Brussels store`;
                  }
                } else if (closestDiv.getAttribute('data-val-brussels') == 'false' || closestDiv.getAttribute('data-val-brussels') == '') {
                  parisAvail.classList.remove('active-brussels');
                  parisAvail.classList.add('non-active-brussels');
                  storeOptions.classList.remove('active-brussels');
                  storeOptions.classList.add('non-active-brussels');
                  if (brussels_unavailable) {
                    brussels_unavailable.innerHTML = `Size ${size_selected} is not available in Brussels store`;
                  }
                }
              
            }
            dropdown.classList.remove('active');
            dropdown.classList.remove('non-active');
            if (window.innerWidth > 768) {
              dropdown.querySelector('.before_select').innerHTML = $(this).val();
            } else {
              dropdown.querySelector('.before_select').innerHTML = "Selected size";
            }

          });
        });
      });
    });
  }
}

if (document.querySelector(".disable_size")) {
  document.querySelector(".disable_size").addEventListener("click", function() {
    document.querySelectorAll('.dropdown-wrap').forEach((dropdown) => {
      dropdown.classList.add("non-active");
      dropdown.querySelectorAll('input[type="radio"]').forEach(function(e) {
        e.addEventListener('change', function(button) {
          if (e.hasAttribute('store-only')) {
            document.querySelector('.choose-cart').classList.add('store-only');
            setTimeout(() => {
              document.querySelector('.btn.get-notified.klaviyo-bis-trigger span').innerHTML = 'JOIN WAITLIST';
            }, 500);
          } else {
            document.querySelector('.choose-cart').classList.remove('store-only');
          }
          var belgiumStore = document.querySelector('.belgium_stores');
          var parisAvail = document.querySelector('.paris_avail');
          if (parisAvail && parisAvail.getAttribute('data-store-selected') === '') {
            belgiumStore.innerHTML = `View store availability for size ${e.value}`;
          }

          if (parisAvail) {
            parisAvail.setAttribute('data-size-selected', e.value);
          }
          

          if (document.querySelector('.paris_avail')) {
            var parisAvail = document.querySelector('.paris_avail');
            var storeOptions = document.querySelector('.store_options');
            var closestDiv = e.closest('div');
            var paris_available = document.querySelector('.paris_available a');
            var paris_unavailable = document.querySelector('.paris_unavailable');
            var brussels_available = document.querySelector('.brussels_available a');
            var brussels_unavailable = document.querySelector('.brussels_unavailable');
            var antwerp_available = document.querySelector('.antwerp_available a');
            var antwerp_unavailable = document.querySelector('.antwerp_unavailable');
            var size_selected = parisAvail.getAttribute('data-size-selected');
            

            if (closestDiv.getAttribute('data-val-paris') == 'true') {
              parisAvail.classList.add('active-paris');
              parisAvail.classList.remove('non-active-paris');
              storeOptions.classList.add('active-paris');
              storeOptions.classList.remove('non-active-paris');
              if (paris_available) {
                paris_available.innerHTML = `Size ${size_selected} is available in Paris store`;
              }
            } else if (closestDiv.getAttribute('data-val-paris') == 'false' || closestDiv.getAttribute('data-val-paris') == '') {
              parisAvail.classList.remove('active-paris');
              parisAvail.classList.add('non-active-paris');
              storeOptions.classList.remove('active-paris');
              storeOptions.classList.add('non-active-paris');
              if (paris_unavailable) {
                paris_unavailable.innerHTML = `Size ${size_selected} is not available in Paris store`;
              }
            }
          
            if (closestDiv.getAttribute('data-val-antwerp') == 'true') {
              parisAvail.classList.add('active-antwerp');
              parisAvail.classList.remove('non-active-antwerp');
              storeOptions.classList.add('active-antwerp');
              storeOptions.classList.remove('non-active-antwerp');
              if (antwerp_available) {
                antwerp_available.innerHTML = `Size ${size_selected} is available in Antwerp store`;
              }
            } else if (closestDiv.getAttribute('data-val-antwerp') == 'false' || closestDiv.getAttribute('data-val-antwerp') == '') {
              parisAvail.classList.remove('active-antwerp');
              parisAvail.classList.add('non-active-antwerp');
              storeOptions.classList.remove('active-antwerp');
              storeOptions.classList.add('non-active-antwerp');
              if (antwerp_unavailable) {
                antwerp_unavailable.innerHTML = `Size ${size_selected} is not available in Antwerp store`;
              }
            }
                        
            if (closestDiv.getAttribute('data-val-brussels') == 'true') {
              parisAvail.classList.add('active-brussels');
              parisAvail.classList.remove('non-active-brussels');
              storeOptions.classList.add('active-brussels');
              storeOptions.classList.remove('non-active-brussels');
              if (brussels_available) {
                brussels_available.innerHTML = `Size ${size_selected} is available in Brussels store`;
              }
            } else if (closestDiv.getAttribute('data-val-brussels') == 'false' || closestDiv.getAttribute('data-val-brussels') == '') {
              parisAvail.classList.remove('active-brussels');
              parisAvail.classList.add('non-active-brussels');
              storeOptions.classList.remove('active-brussels');
              storeOptions.classList.add('non-active-brussels');
              if (brussels_unavailable) {
                brussels_unavailable.innerHTML = `Size ${size_selected} is not available in Brussels store`;
              }
            }
          }
          dropdown.classList.remove('active');
          dropdown.classList.remove('non-active');
          if (window.innerWidth > 768) {
            dropdown.querySelector('.before_select').innerHTML = $(this).val();
          } else {
            dropdown.querySelector('.before_select').innerHTML = "Selected size";
          }

          // if (window.innerWidth <= 767) {
          //   var vr = e.closest('variant-radios');
          //   if (vr) {
          //     $(vr).slideUp();
          //     document.body.classList.remove('open_variant');
          //     $('.choose-cart').css('display', 'grid').removeClass('hide-selectore-button');
          //     $('.choose-selector').hide();
          //   }
          // }
        });
      });
    });
  });
}
document.querySelector('.product-addcart').addEventListener('click',function(evt){
  evt.preventDefault();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  var cartform = document.querySelector('.product-addcart').closest('form');
  const formData = new FormData(cartform);  
  if ($(window).width() <= 767){
    $('variant-radios').slideUp();
  $('.choose-cart').addClass('hide-selectore-button');
  $('.choose-selector').removeClass('hide-selectore-button').css('display','grid');
    atc_bar();
  }
  $('body').removeClass('open_variant');  
  config.body = formData;
  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      if ($(window).width() >= 768){
        document.querySelector('.product-form-error').innerHTML = response.description;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
      },2000);
      }
      else if($(window).width() <= 767){
      $('.cart-added').addClass('active');
        document.querySelector('.blackbar-error').innerHTML = response.description;
        $('.blackbar-error').show(); 
        $('.blackbar-text').hide();   
        setTimeout(function(){
          $('.cart-added').removeClass('active');
        }, 4000);
        
      }
      
      return;
    }else{
      if ($(window).width() >= 768){
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
      }
      else if($(window).width() <= 767){
        if(typeof load_cart == 'function'){
          load_cart();
          setTimeout(function(e){
            $('.cart-added').addClass('active');
            $('.blackbar-error').hide(); 
            $('.blackbar-text').show();
            setTimeout(function(){
              $('.cart-added').removeClass('active');
            }, 4000);
          },500);
        }else{
          window.location.href = "/cart";
        }
      }
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {

  });
});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: "auto"
    });
     var swiper3 = new Swiper(".zoom_swiper_main", {
      loop: true,
      slidesPerView: "auto",
      observer: true,
      observeParents: true,
      autoHeight: true,
      navigation: {
        nextEl: ".swiper-button-next-new",
        prevEl: ".swiper-button-prev-new",
      },
    });

    
    if(window.innerWidth > 575){

      // var swiper2 = new Swiper(".media-nav", {
      //   spaceBetween: 0,
      //   loop: true,
      //   mousewheel: {
      //     enabled: true,
      //     forceToAxis: true,
      //   },
      //   slidesPerView: "auto",
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev",
      //   },
      //   pagination: {
      //     el: ".swiper-pagination",
      //   },
      //   thumbs: {
      //     swiper: swiper,
      //   },
      //   speed:1000,
      //   autoplay: {
      //      delay: 2000,
      //      disableOnInteraction: false,
      //       pauseOnMouseEnter: true
      //   }
      // });

      // document.querySelector(".product-media").style.pointerEvents = "none";

      // var mediaNav = document.querySelector(".media-nav .swiper-wrapper");
      // var slides = mediaNav.querySelectorAll(".swiper-slide");
      // var slideCount = slides.length;

      // if (slideCount < 4) {
      //   for (var i = 0; i < 4 - slideCount; i++) {
      //     mediaNav.appendChild(slides[i].cloneNode(true));
      //   }
      // }

      // var swiper2 = new Swiper(".media-nav", {
      //   spaceBetween: 0,
      //   loop: true,
      //   loopedSlides: 5,
      //   mousewheel: {
      //     enabled: true,
      //     forceToAxis: true,
      //   },
      //   slidesPerView: "auto",
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev",
      //   },
      //   pagination: {
      //     el: ".swiper-pagination",
      //   },
      //   thumbs: {
      //     swiper: swiper,
      //   },
      //   speed: 1000,
      //   autoplay: {
      //     delay: 2000,
      //     disableOnInteraction: false,
      //     pauseOnMouseEnter: true,
      //   },

      //   on: {
      //     init: function () {
      //       document.querySelector(".product-media").style.pointerEvents = "auto";
      //     },
      //   },
      // });


      // document.querySelector(".product-media").style.pointerEvents = "none";
      // var mediaNav = document.querySelector(".media-nav .swiper-wrapper");
      // var slides = mediaNav.querySelectorAll(".swiper-slide");
      // var slideCount = slides.length;
      // if (slideCount < 4) {
      //   for (var i = 0; i < 4 - slideCount; i++) {
      //     mediaNav.appendChild(slides[i % slideCount].cloneNode(true));
      //   }
      // }
      // var swiper2 = new Swiper(".media-nav", {
      //   spaceBetween: 0,
      //   loop: true,
      //   loopedSlides: Math.min(5, mediaNav.querySelectorAll(".swiper-slide").length),
      //   slidesPerView: 'auto', 
      //   mousewheel: {
      //     enabled: true,
      //     forceToAxis: true,
      //   },
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev",
      //   },
      //   pagination: {
      //     el: ".swiper-pagination",
      //   },
      //   thumbs: {
      //     swiper: swiper,
      //   },
      //   speed: 1000,
      //   autoplay: {
      //     delay: 2000,
      //     disableOnInteraction: false,
      //     pauseOnMouseEnter: true,
      //   },
      //   on: {
      //     init: function () {
      //       document.querySelector(".product-media").style.pointerEvents = "auto";
      //     },
      //   },
      // });

      
//     document.querySelector(".product-media").style.pointerEvents = "none";

//     var mediaNav = document.querySelector(".media-nav .swiper-wrapper");
//     var slides = mediaNav.querySelectorAll(".swiper-slide");
//     var slideCount = slides.length;

    
//     if (slideCount < 4) {
//       for (var i = 0; i < 4 - slideCount; i++) {
//         mediaNav.appendChild(slides[i % slideCount].cloneNode(true));
//       }
//     }

    
//     var totalSlides = mediaNav.querySelectorAll(".swiper-slide").length;
// // console.log(totalSlides);
//     var swiper2 = new Swiper(".media-nav", {
//       spaceBetween: 0,
//       loop: true,
//       loopedSlides: totalSlides,
//       slidesPerView: "auto",
//       mousewheel: {
//         enabled: true,
//         forceToAxis: true,
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//       pagination: {
//         el: ".swiper-pagination",
//       },
//       thumbs: {
//         swiper: swiper,
//       },
//       speed: 1000,
//       autoplay: {
//         delay: 2000,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//       },
//       on: {
//         init: function () {
//           document.querySelector(".product-media").style.pointerEvents = "auto";
//         },
//       },
//     });


// disable interactions while building
document.querySelector(".product-media").style.pointerEvents = "none";

(function () {
  var wrapper = document.querySelector(".media-nav .swiper-wrapper");
  if (!wrapper) {
    document.querySelector(".product-media").style.pointerEvents = "auto";
    return;
  }

  // Freeze original slides (avoid live NodeList issues)
  var originalSlides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
  var originalCount = originalSlides.length;
  if (originalCount === 0) {
    document.querySelector(".product-media").style.pointerEvents = "auto";
    return;
  }

  // Conservative minimum number of slides to ensure smooth looping in Safari
  // var MIN_TOTAL = 6; // change to 4 if you prefer fewer clones
  // if (originalCount < MIN_TOTAL) {
  //   var toClone = MIN_TOTAL - originalCount;
  //   var frag = document.createDocumentFragment();
  //   for (var i = 0; i < toClone; i++) {
  //     // clone from the frozen originalSlides array
  //     frag.appendChild(originalSlides[i % originalCount].cloneNode(true));
  //   }
  //   wrapper.appendChild(frag);
  // }

  // re-count total slides after cloning
  var totalSlides = wrapper.querySelectorAll(".swiper-slide").length;

  // Build Swiper config; attach thumbs only if a 'swiper' instance exists in scope
  var config = {
    spaceBetween: 0,
    slidesPerView: "auto",         // keep your thumbnail sizing behavior
    loop: true,                    // always loop because we cloned enough slides
    loopedSlides: totalSlides,
    loopAdditionalSlides: totalSlides,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    mousewheel: { enabled: true, forceToAxis: true },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: { el: ".swiper-pagination", clickable: true },
    speed: 900,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    on: {
      init: function () {
        // re-enable pointer events only once Swiper is ready
        document.querySelector(".product-media").style.pointerEvents = "auto";
      }
    }
  };

  // only add thumbs if a global 'swiper' variable exists (avoid ReferenceError)
  if (typeof swiper !== "undefined") {
    config.thumbs = { swiper: swiper };
  }

  // init
  var thumbSwiper = new Swiper(".media-nav", config);

  // force update and position so navigation behaves predictably
  thumbSwiper.update();
  // ensure we're on a looped index to avoid any end/beginning quirks
  try { thumbSwiper.slideToLoop(0, 0); } catch (e) { /* silent */ }

  // small guard: if you still see one-directional behavior, try these event fixes:
  thumbSwiper.on("transitionEnd", function () { thumbSwiper.update(); });
})();



    }else{
        var swiper2 = new Swiper(".media-nav", {
        spaceBetween: 0,
        loop: true,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
        thumbs: {
          swiper: swiper,
        }
      });
    }
    
    $(document).on('click','.media-grid-column',function(e){
      let data_Index = $(this).attr('data-swiper-slide-index');
      if(window.innerWidth > 768){
        $('body').addClass("overflow-hidden")
        $("#Zoom_swiper").show();
      }
      swiper3.slideTo(data_Index, 0);
    });

    swiper3.on('slideChange', function (e) {  
      var rwalSlide = document.querySelector('.zoom_swiper_main [data-swiper-slide-index="'+e.realIndex+'"] .media-grid-inner');
      document.querySelector('.zoom_swiper_main').style.height = rwalSlide.clientHeight+'px';  
    });
  }
  
}
product_slider();





variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top - 67
}
function doScrolling(element, duration) {
  console.log('jigi')
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
// if(document.querySelector('.simple_info .choose-selector')){
//   if (window.innerWidth <= 768) {
//     document.querySelector('.simple_info .choose-selector a').addEventListener('click', doScrolling.bind(null, '.product-media', 500))
//   }
// }



if ($(window).width() <= 767){
  new Swiper('.inner-media', {
    slidesPerView: 1,
    /*pagination: {
        el: ".swiper-pagination",
    }*/
  });
  $('.choose-selector').removeClass('hide-selectore-button');
  $(document).ready(function() {
  var h_height = $('.section-header').outerHeight(),
    pr_ttl_height = $('.inner_info_fixed').outerHeight(),
    w_ht = $(window).height(),    
    t_ht = w_ht - (h_height + pr_ttl_height);
  $('.product-media').height(t_ht);
    var in_top = $('.inner_info_fixed').offset().top;
var m_t_ht = 0;
     $(document).on('click', '.disable_size', function(){
       m_t_ht = $('.product-media').outerHeight() + h_height + pr_ttl_height;
      $('variant-radios').slideToggle();
      $('body').toggleClass('open_variant');
      if ($('.variant-dropdown-list>div input[type=radio]:checked').length > 0){
        $('.choose-cart').css('display', 'grid').removeClass('hide-selectore-button');
        $('.choose-selector').hide();
      }      
    });
    $(document).on('click', '.simple_info .disable_size', function(){
      $( 'html, body' ).animate({
      scrollTop: 0
      }, 500 );
    });

    
    $(window).on('scroll', function(){
      m_t_ht = $('.product-media').outerHeight() + h_height + pr_ttl_height;
      if (w_ht < m_t_ht){
         $('.product-media').height(t_ht);
      }
      var s_top = $(window).scrollTop();
      if(s_top >= in_top){
           //$('.inner_info_fixed').addClass('sticky_fixed').removeClass('simple_info');  
        //$('body').css('padding-top', pr_ttl_height);
        $('#shopify-section-header').addClass('no_sticky');
      }
      else{
       //$('.inner_info_fixed').removeClass('sticky_fixed').addClass('simple_info');
        //$('body').css('padding-top', 0);
        $('#shopify-section-header').removeClass('no_sticky');
      }
      // if(s_top >= (in_top - 66) ){
      //   $('#shopify-section-header').addClass('no_sticky');
      // }
      // else{
      //   $('#shopify-section-header').removeClass('no_sticky');
      // }
      atc_bar();


      var top_total_offset = $(window).height() + s_top;
      var top_info = $('.product-info').offset().top;
      var info_total = $('.inner_info_fixed').offset().top;
      if(top_total_offset >= top_info){
        $('.inner_info_fixed').removeClass('simple_info');
      }
      else{
        $('.inner_info_fixed').addClass('simple_info');
      }
      if (top_info <= s_top){
        $('.inner_info_fixed').addClass('sticky_fixed');
      }
      else{
        $('.inner_info_fixed').removeClass('sticky_fixed');
      }
      
    });
   
});
  $(document).on('click','.close-blackbar',function(e){
  $('.blackbar').removeClass('active');
  return false;
});

$('body').on('click',function(e){
  var container = $(".inner_info_fixed");
  if (!container.is(e.target) && container.has(e.target).length === 0){
    $('variant-radios').slideUp();
    $('body').removeClass('open_variant'); 
    $('.choose-cart').hide();
    if (window.matchMedia("(max-width: 767px)").matches) {
      $('.store_options').removeClass('show');
      $('.store_options').addClass('hide');      
      if ($('.paris_avail').attr('data-store-selected') === "") {
        $('.store_select').html("Select store");
      } else {
        $('.store_select').html("Change store");
      }
      setTimeout(function() {
        $('.store_options').hide();
      }, 300);
    }
    $('.choose-selector').removeClass('hide-selectore-button').css('display','grid')
  }
});
const media_height = () => {
    const docs = document.querySelector('.open_variant .product-media');
  const m_hright = `${window.innerHeight}`;
  const h_height = $('.section-header').outerHeight();
    const pr_ttl_height = $('.inner_info_fixed').outerHeight();
  const t_ht = m_hright - (h_height + pr_ttl_height);
    docs.style.setProperty('height', t_ht+'px')
}
window.addEventListener('resize', media_height)
}
if ($(window).width() >= 768){
  $('body').on('click',function(e){
    var container = $(".variant-dropdown-list, .variant-dropdown");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      $('.dropdown-wrap').removeClass('active');
    }
  });
}
function atc_bar(){
  if ($('.sticky_fixed').length > 0){
    $('.blackbar').css('top', '0');
  }
  else{
    $('.blackbar').css('top', $('.section-header').outerHeight());
  }
}

$(document).on('click', '.size_link a', function(){
  $('body').addClass('open_sgiude')
})
$(document).on("click","#close_zoom_slider",function(){
  $('body').removeClass("overflow-hidden");
     $("#Zoom_swiper").hide();
  $("body").removeClass("overFlow-zoom");
})
$(".zoom_swiper_main").dblclick(function(){
  $("#close_zoom_slider").trigger("click");
});

document.querySelectorAll('.store_select').forEach(storeSelect => {
  const store_select = document.querySelector('.store_select');
  const originalContent = store_select.innerHTML;
  storeSelect.addEventListener('click', function() {
    var storeOptions = document.querySelector('.store_options');
    var storeList = document.querySelector('.store_list');
    var wrappap = document.querySelector('.wrappap');
    var colorSelector = document.querySelector('.color_selector');
    var addCartSnippet = document.querySelector('.snippet-addto-cart');
    var chooseCart = document.querySelector('.choose-cart');
    var store_selects = document.querySelectorAll('.store_select');

    if (storeOptions.style.display === 'none' || storeOptions.style.display === '') {
      storeOptions.style.display = 'block';
      storeList.style.display = 'flex';
      if (window.innerWidth > 767) {
        storeList.style.background = 'white';
        storeList.style.boxShadow = '0 0 0 1px black';
        storeOptions.style.position = 'absolute';
        storeOptions.style.width = '100%';
        store_selects.forEach(store_select => {
          store_select.innerHTML = "Close";
        });
      }
      if (window.innerWidth <= 767) {
        document.body.classList.add('open_variant');
        storeOptions.classList.remove('hide');
        storeOptions.classList.add('show');
        store_selects.forEach(store_select => {
          store_select.innerHTML = "Close";
        });
        $('variant-radios').slideUp();
      }
    } else {
      if (window.innerWidth > 767) {
          storeOptions.style.display = 'none';
          wrappap.style.display = '';
          colorSelector.style.display = '';
          addCartSnippet.style.marginBottom = '';
          store_selects.forEach(store_select => {
            store_select.innerHTML = originalContent;
          });
      }
      if (window.innerWidth <= 767) {
        if (chooseCart.style.display !== 'grid') {
          document.body.classList.remove('open_variant');
        }
        setTimeout(() => {
          storeOptions.style.display = 'none';
        }, 300);
        store_selects.forEach(store_select => {
          store_select.innerHTML = originalContent;
        });
        storeOptions.classList.remove('show');
        storeOptions.classList.add('hide');
        if (chooseCart.style.display === 'grid') {
          $('variant-radios').slideToggle();
        }
      }
    }
  });
});

document.querySelectorAll('.store_container[data-store]').forEach(button => {
  var wrappap = document.querySelector('.wrappap');
  var colorSelector = document.querySelector('.color_selector');
  var addCartSnippet = document.querySelector('.snippet-addto-cart');
  var chooseCart = document.querySelector('.choose-cart');
  var storeOption = document.querySelector('.store_options');
  button.addEventListener('click', () => {
    var storeValue = button.getAttribute('data-store');    
    document.querySelectorAll('.store_last, .store_options').forEach(element => {
      element.style.display = 'none';
    });
    wrappap.style.display = '';
    colorSelector.style.display = '';
    addCartSnippet.style.marginBottom = '';
    storeOption.classList.remove('show');
    storeOption.classList.add('hide');
    const paragraphOnlineExclu = document.querySelector('.paris_avail p.online-exclu');
    const paragraph = document.querySelector('.paris_avail p');
    function capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    newStoreValue = capitalize(storeValue);

    if (paragraphOnlineExclu) {
      paragraphOnlineExclu.innerHTML = 'Only available online';
    } else if (paragraph) {
      paragraph.innerHTML = `Select a size to see ${newStoreValue} store availability`;
    }

    document.querySelector('[data-store-selected]').setAttribute('data-store-selected', storeValue);
    document.querySelectorAll('.store_select').forEach(storeSelect => {
      storeSelect.innerHTML = "Change store";
    });
    if (window.innerWidth <= 767) {
      document.body.classList.remove('open_variant');
      if (chooseCart.style.display === 'grid') {
        $('variant-radios').slideToggle();
      }
    }
    sessionStorage.setItem('selectedStore', storeValue);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  var storedStoreValue = sessionStorage.getItem('selectedStore');
  const paragraphOnlineExclu = document.querySelector('.paris_avail p.online-exclu');
  const paragraph = document.querySelector('.paris_avail p');
  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  newStoreValue = capitalize(storedStoreValue);

  if (storedStoreValue) {
    document.querySelector('[data-store-selected]').setAttribute('data-store-selected', storedStoreValue);
    if (paragraphOnlineExclu) {
      paragraphOnlineExclu.innerHTML = 'Only available online';
    } else if (paragraph) {
      paragraph.innerHTML = `Select a size to see ${newStoreValue} store availability`;
    }
    document.querySelectorAll('.store_select').forEach(storeSelect => {
      storeSelect.innerHTML = "Change store";
    });
  }
});